import { Unity, useUnityContext } from 'react-unity-webgl';
import { useEffect, useState } from 'react';
import { useScript } from '../../../utils/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import { useCallback } from 'react';
import { useAdsListener } from '../../../services/admob';

const PREFIX_URL = '/game-egg';

// TODO - Modal로 게임을 미리 로딩 후 사용자 클릭시 바로 게임 볼 수 있도록

export default function YaongEgg() {
  // 유니티 구동을 위함
  useScript(PREFIX_URL + `/JS/YaongEgg.js`);

  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  // We'll use a state to store the device pixel ratio.
  const [devicePixelRatio, setDevicePixelRatio] = useState(window.devicePixelRatio);

  const {
    unityProvider,
    sendMessage,
    addEventListener,
    removeEventListener,
    loadingProgression,
    isLoaded: unityIsLoaded,
  } = useUnityContext({
    loaderUrl: PREFIX_URL + '/Build/Build.loader.js',
    dataUrl: PREFIX_URL + '/Build/Build.data',
    frameworkUrl: PREFIX_URL + '/Build/Build.framework.js',
    codeUrl: PREFIX_URL + '/Build/Build.wasm',
  });

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [isFullyReady, setIsFullyReady] = useState(false); // Unity 완전 준비 상태
  const pendingCallsRef = useRef([]); // 대기 중인 함수 호출들
  const readyTimeoutRef = useRef(null);
  const adCallbackRef = useRef([]); // 광고 콜백 대기 함수

  const mode = queryParams.get('mode'); // ?mode=merge → "merge"

  // 안전한 Unity 함수 호출
  const fnSendMessage = useCallback(
    (goName, fnResult, arg) => {
      if (isFullyReady) {
        // Unity가 완전히 준비되어 있으면 즉시 호출
        try {
          console.log('Sending message immediately:', goName, fnResult, arg);
          sendMessage(goName, fnResult, arg);
        } catch (error) {
          console.error('Unity sendMessage failed:', error);
        }
      } else {
        // Unity가 아직 준비되지 않았으면 대기열에 추가
        console.log('Unity not ready, queuing message:', goName, fnResult, arg);
        pendingCallsRef.current.push({ goName, fnResult, arg });
      }
    },
    [isFullyReady, sendMessage],
  );

  // 대기 중인 함수 호출들 처리
  const processPendingCalls = useCallback(() => {
    if (pendingCallsRef.current.length > 0 && isFullyReady) {
      // console.log(`Processing ${pendingCallsRef.current.length} pending Unity calls`);

      pendingCallsRef.current.forEach(({ goName, fnResult, arg }) => {
        try {
          sendMessage(goName, fnResult, arg);
          console.log(`Unity call executed: ${goName}.${fnResult}(${arg})`);
        } catch (error) {
          console.error(`Unity call failed: ${goName}.${fnResult}`, error);
        }
      });

      // 호출 완료 후 대기 목록 초기화
      pendingCallsRef.current = [];
    }
  }, [isFullyReady, sendMessage]);

  // 광고 시청 후 콜백 핸들러
  async function checkAdsEgg() {
    console.log('광고 실행 후 정상 콜백 되엇나요??');

    adCallbackRef.current.forEach(({ goName, fnResult, arg }) => {
      try {
        sendMessage(goName, fnResult, arg);
        console.log(`checkAdsEgg executed: ${goName}.${fnResult}(${arg})`);
      } catch (error) {
        console.error(`checkAdsEgg failed: ${goName}.${fnResult}`, error);
      }
    });
  }

  useAdsListener('', '', { task: 'game-egg' }, checkAdsEgg);

  useEffect(() => {
    if (loadingProgression === 1) {
      setIsLoaded(true);
    }
  }, [loadingProgression]);

  // react-unity-webgl의 isLoaded도 함께 확인 (더 안전한 방법)
  useEffect(() => {
    if (unityIsLoaded && loadingProgression === 1) {
      setIsLoaded(true);
      const canvas = document.querySelector('canvas');
      if (canvas) {
        const dpr = window.devicePixelRatio || 1;
        canvas.width = canvas.clientWidth * dpr;
        canvas.height = canvas.clientHeight * dpr;
      }

      if (readyTimeoutRef.current) {
        clearTimeout(readyTimeoutRef.current);
      }

      readyTimeoutRef.current = setTimeout(() => {
        setIsFullyReady(true);
      }, 500);
    }
  }, [unityIsLoaded, loadingProgression]);

  // 대기 중인 호출들 처리
  useEffect(() => {
    processPendingCalls();
  }, [processPendingCalls]);

  // Unity 이벤트 리스너 등록
  useEffect(() => {
    const handleUnityLoaded = () => {
      console.log('Unity loaded event received');
      setIsFullyReady(true);
    };

    const handleUnityError = (message) => {
      console.error('Unity error:', message);
    };

    // Unity 이벤트 리스너 등록 (선택사항)
    if (addEventListener) {
      addEventListener('GameLoaded', handleUnityLoaded);
      addEventListener('Error', handleUnityError);
    }

    return () => {
      if (removeEventListener) {
        removeEventListener('GameLoaded', handleUnityLoaded);
        removeEventListener('Error', handleUnityError);
      }
    };
  }, [addEventListener, removeEventListener]);

  // Unity에서 호출할 함수 전역 등록
  useEffect(() => {
    window.SendToHtml = function (protocol, goName, fnResult) {
      // console.log('SendToHtml called:', protocol, goName, fnResult);

      if (protocol === 'mode' && mode !== null) {
        // console.log('Mode protocol, sending mode:', mode);
        fnSendMessage(goName, fnResult, mode);
      } else if (protocol === 'ads') {
        console.log('Ads protocol triggered');
        // 여기서 광고 시청 호출
        window.flutter_inappwebview.callHandler('run_admob', '');
        adCallbackRef.current.push({ goName, fnResult, arg: 1 }); // 광고 콜백 대기 함수에 추가
      } else if (protocol === 'quit') {
        navigate('/', { replace: true });
      }
    };

    return () => {
      // 컴포넌트 언마운트 시 정리
      delete window.SendToHtml;
      if (readyTimeoutRef.current) {
        clearTimeout(readyTimeoutRef.current);
      }
    };
  }, [mode, fnSendMessage, navigate]);

  useEffect(
    function () {
      const updateDevicePixelRatio = function () {
        setDevicePixelRatio(window.devicePixelRatio);
        console.log('Updating device pixel ratio:', window.devicePixelRatio);
      };
      const mediaMatcher = window.matchMedia(`screen and (resolution: ${devicePixelRatio}dppx)`);
      mediaMatcher.addEventListener('change', updateDevicePixelRatio);
      return function () {
        mediaMatcher.removeEventListener('change', updateDevicePixelRatio);
      };
    },
    [devicePixelRatio],
  );

  return (
    <div className='unity-container'>
      {!isLoaded && <div className='loading-bar'>{Math.round(loadingProgression * 100)}%</div>}
      <Unity
        unityProvider={unityProvider}
        style={{
          width: '100%',
          height: '100vh',
          maxWidth: '1280px',
          visibility: isLoaded ? 'visible' : 'hidden',
        }}
        devicePixelRatio={devicePixelRatio}
      />
    </div>
  );
}
